import { HTTP } from '@/utils/http';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  actions: {
    async [actions.DO_GET_WAIVER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/waivers/${id}`, { params });
      commit(mutations.SET_WAIVER, data.data.waivers[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_WAIVER]: state => state.waiver,
  },
  mutations: {
    [mutations.SET_WAIVER](state, waiver) {
      state.waiver = waiver;
    },
  },
  state: {
    waiver: {},
  },
};
